<template>
    <div class="container-fluid" style="height: 100%">
      <div class="row" style=" min-height: 58em; z-index: 1;">
        <div class="col-sm-12" id="subscribe-container" style="">
          <div class="login-container" v-if="displayBlock ==='login'">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center m-b-md">
                  <h3 v-if="isEmailExist === true" style="font-weight: bold;">Step 1/2: Login to your account</h3>
                  <template v-else>
                    <i class="far fa-handshake fa-4x"></i>
                    <h3 style="font-weight: bold;">Enter your Email to continue</h3>
                  </template>
                </div>
                <div class="hpanel">
                  <div class="panel-body">
                    <form v-on:submit="login" action="#" method="post" id="loginForm">
                      <div class="form-group">
                        <label class="control-label required" for="email">{{ $t('signIn.form_email.label') }}</label>
                        <input v-model="email" type="text" v-bind:placeholder="$t('signIn.form_email.place_holder')"
                               v-bind:title="$t('signIn.form_email.title')" required value="" name="email" id="email"
                               class="form-control">
                      </div>

                      <div class="form-group" v-if="isEmailExist === true">
                        <label class="control-label required" for="password">{{ $t('signIn.form_password.label') }}</label>
                        <input v-model="password" type="password" v-bind:title="$t('signIn.form_password.title')"
                               v-bind:placeholder="$t('signIn.form_password.place_holder')" required value=""
                               name="password"  id="password" class="form-control" autocomplete="false">
                      </div>

                      <div v-if="errorLogin !== null" class="alert alert-danger" style="margin: 10px 0">
                        {{errorLogin}}
                      </div>
                      <template v-if="isEmailExist === true">
                        <div class="checkbox checkbox-info">
                          <input type="checkbox" checked id="rememberMe" v-model="rememberMe">
                          <label for="rememberMe">{{ $t('signIn.form_remember.label') }}</label>
                          <p class="help-block small">({{ $t('signIn.form_remember.help_block') }})</p>
                        </div>

                        <div v-if="accountExpired" class="m-t-sm m-b-sm alert alert-danger text-center">
                          <div class="m-t-xs m-b-xs">Your account has expired!</div>
                          <div>You can reactivate it by contacting us at <a href="mailto:sales@idexlab.com">sales@idexlab.com.</a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-2 col-xs-12 m-b-xs"></div>
                          <div class="col-sm-8 col-xs-12 m-b-xs">
                            <vue-ladda type="submit" :loading="submitLogin.loading"
                                       class="btn btn-info btn-block m-t-xs" :data-style="submitLogin.dataStyle">{{
                              $t('signIn.form.login') }}
                            </vue-ladda>
                          </div>
                        </div>

                        <div class="text-center" style="margin-top: 10px">
                          <router-link :to="{name: 'ForgotPassword'}" class="text-info"><b>Forgot password</b>
                          </router-link>
                        </div>
                      </template>
                      <template v-else>
                        <vue-ladda type="button" :loading="checkEmailButton.loading" class="btn btn-info btn-block"
                                   :data-style="checkEmailButton.dataStyle" @click="checkEmail($event)">Continue
                        </vue-ladda>
                      </template>
                    </form>
                    <template v-if="isEmailExist === true">
                      <div class="dividerWrapper m-t m-b-md">
                        <div class="dividerContent">or Login with</div>
                      </div>
                      <div class="row">
                        <div class="m-b-sm col-sm-3 col-xs-12">
                          <router-link class="btn btn-info btn-block btn-outline" :to="{name: 'SsoConnection', params: {provider: 'linkedin'}}"><i class="fab fa-linkedin-in"></i> Linkedin</router-link>
                        </div>
                        <div class="m-b-sm col-sm-3 col-xs-12">
                          <router-link class="btn btn-info btn-block btn-outline" :to="{name: 'SsoConnection', params: {provider: 'google'}}"><i class="fab fa-google"></i> Google</router-link>
                        </div>
                        <div class="m-b-sm col-sm-3 col-xs-12">
                          <router-link class="btn btn-info btn-block btn-outline" :to="{name: 'SsoConnection', params: {provider: 'facebook'}}"><i class="fab fa-facebook-square text-info"></i> Facebook</router-link>
                        </div>
                        <div class="m-b-sm col-sm-3 col-xs-12">
                          <router-link class="btn btn-info btn-block btn-outline" :to="{name: 'SsoConnection', params: {provider: 'azure'}}"><i class="fab fa-brands fa-microsoft text-info"></i> Microsoft Azure</router-link>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="displayBlock ==='register'">
            <simplified-registration :title="'Register for free to start your trial'" :buttonLogin="false"
                                     :emailPrefilled="email"></simplified-registration>
          </div>
          <div class="row m-b m-t-xs">
            <div class="col-md-12 text-center" style="background-color: #ffffff9e; z-index: 500;">
              <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright
              Idexlab
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<style scoped>
  .dividerWrapper {
    width: 100%;
    height: 20px;
    border-bottom: 1px solid #eaeaea;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

  }
  .dividerContent {
    background-color: #fff;
    padding: 0 20px;
    margin-top: 1em;
  }
  @media (min-width: 990px) {
    .left-col-cover {
      background: url('https://www.idexlab.com/openisme/wp-content/uploads/2020/11/4-5-sans-texte.png') 0px 0px no-repeat;
      -webkit-background-size: cover;
      background-size: cover;
      height: 100%;
    }
    #signup-form {
      overflow: auto;
    }
  }

  .login-container {
    padding-top: 0;
  }

  .hpanel .panel-body { border: 1px solid #eaeaea;}
</style>
<script>

import VueLadda from 'vue-ladda'
import SimplifiedRegistration from '../../components/register/SimplifiedRegistration'
import RegisterLeftBox from '../../components/register/RegisterLeftBox'

export default {
  components: {SimplifiedRegistration, VueLadda, RegisterLeftBox},
  name: 'Subscribe',
  methods: {
    checkEmail: function (event) {
      if (this.email) {
        this.checkEmailButton.loading = true

        if (typeof (_gaq) !== 'undefined') {
          _gaq.push(['_trackEvent', 'Subscribe', 'Click_button', 'check email if exist'])
        }
        this.axios.post('/auth/checkEmail/', {email: this.email})
          .then((response) => {
            this.checkEmailButton.loading = false
            this.isEmailExist = response.data.email_exist
            if (typeof (_gaq) !== 'undefined') {
              var checkEmaiEvent = this.isEmailExist ? ['_trackEvent', 'Subscribe', 'Email_exist', 'check email exist return true'] : ['_trackEvent', 'Subscribe', 'Email_not_exist', 'check email exist return false']
              _gaq.push(checkEmaiEvent)
            }
          }).catch((resp) => {
            this.checkEmailButton.loading = false
            if (resp.response.status === 400) {
              let errors = resp.response.data.errors
              this.errorLogin = errors['email'][0]
            }
          })
      } else {
        this.errorLogin = 'Please enter a valid email address.'
      }
      if (event) {
        event.stopPropagation()
      }
    },
    login: function (event) {
      if (!this.password) {
        event.preventDefault()
        this.checkEmail()
      } else {
        event.preventDefault()
        this.submitLogin.loading = true

        let redirect = this.$auth.redirect()

        this.$auth.login({
          data: {email: this.email.trim(), password: this.password, ip: this.ip},
          redirect: null,
          success: (response) => {
            this.$auth.token(null, response.data.access_token)
            this.submitLogin.loading = false
            localStorage.setItem('is_already_connect', 'true')
            this.$auth.user()

            let plan = localStorage.getItem('register_plan')
            if (plan && plan !== 'basic' && !this.$user.isSe()) {
              this.$router.replace({name: 'Plans'})
            } else if (redirect === null && this.$user.isBasic()) {
              if (this.$user.isSe() || this.$user.hasExpertProfile()) {
                this.$router.replace({name: 'SearchSimple'})
              } else {
                this.$router.replace({name: 'Profile'})
              }
            } else {
              this.$router.replace({
                name: (redirect ? redirect.from.name : 'Dashboard'),
                params: redirect ? redirect.from.params : {},
                query: redirect ? redirect.from.query : {}
              })
            }
            this.$salesMachine.signIn()
          },
          error: (res) => {
            this.password = ''
            if (res.response.status === 400) {
              let errors = res.response.data.errors
              switch (res.response.data.code) {
                case 1:
                  this.errorLogin = errors['email'][0]
                  break
                case 2:
                  this.errorLogin = errors['credentials'][0]
                  break
                case 4:
                  this.accountExpired = true
                  break
              }
            }
            this.submitLogin.loading = false
          },
          rememberMe: this.rememberMe,
          fetchUser: true
        })
      }
    },
    getUserIP: function () {
      this.axios.get('https://ipinfo.io/json')
        .then((response) => {
          if (typeof response.data.ip !== 'undefined' && typeof response.data.ip !== 'undefined' && response.data.ip !== null) {
            this.ip = response.data.ip
          }
        }).catch(function (error) {
        })
    }
  },
  updated () {
    $('#subscribe-container').css('padding-top', ($(window).height() - $('#subscribe-container').height() - 60) / 2)
  },
  mounted () {
    $('#subscribe-container').css('padding-top', ($(window).height() - $('#subscribe-container').height() - 60) / 2)

    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: 'body'
    })
    setTimeout(() => {
      if (document.getElementById('launcher')) {
        document.getElementById('launcher').style.display = 'none'
      }
    }, 6000)
  },
  beforeMount () {
    let trial = this.$route.query.trial

    if (typeof trial === 'undefined') {
      localStorage.removeItem('trial')
    } else {
      localStorage.setItem('trial', trial)
    }

    this.email = (this.$route.query.email) ? this.$route.query.email : this.email
    if (typeof this.$route.query.plan === 'undefined') {
      localStorage.removeItem('register_plan')
      localStorage.removeItem('register_interval')
    } else {
      let plan = this.$route.query.plan
      let interval = this.$route.query.interval
      localStorage.setItem('register_plan', plan)
      localStorage.setItem('register_interval', interval)
    }
    this.getUserIP()
  },
  data () {
    return {
      email: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      password: '',
      errorLogin: null,
      displayBlock: 'login',
      isEmailExist: null,
      accountExpired: false,
      rememberMe: false,
      submitLogin: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      checkEmailButton: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  },
  watch: {
    isEmailExist: function (val) {
      if (val === false) {
        this.displayBlock = 'register'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/register/Subscribe.vue